import React from "react";
import styles from "./Main.module.css";

import { ShopSection } from "../ShopSection/ShopSection";
import { AboutMeSection } from "../AboutMeSection/AboutMeSection";
import { ContactSection } from "../ContactSection/ContactSection";

function Main({ setHidden, setShowGallery, setShowAboutMe }) {
  return (
    <div id="main" className={styles.main}>
      <ShopSection
        setShowShop={setShowGallery}
        setHidden={setHidden}
      ></ShopSection>
      <AboutMeSection
        setShowAboutMe={setShowAboutMe}
        setHidden={setHidden}
      ></AboutMeSection>
      <ContactSection></ContactSection>
    </div>
  );
}

export { Main };
